import request from '@/utils/request'

/**
 * POST 方法 与 GET方法  区别
 *
 * post==> data: obj
 * get==>params: obj
 *
 */
export function postUserInfo(obj: any) {
  return request({
    url: '/login',
    method: 'post',
    data: obj,
  })
}
export function getPrice(obj: any) {
  return request({
    url: '/car/pricelevels',
    method: 'get',
    params: obj,
  })
}
export function getLevel(obj: any) {
  return request({
    url: '/car/serieslevels',
    method: 'get',
    params: obj,
  })
}
export function getBrand(obj: any) {
  return request({
    url: '/car/brands',
    method: 'get',
    params: obj,
  })
}

export function getZbcj(obj: any) {
  return request({
    url: '/mcn/club/list',
    method: 'get',
    params: obj,
  })
}
export function getVoteCount(obj: any) {
  return request({
    url: '/miniAppVoteNumApi',
    method: 'get',
    params: obj,
  })
} 
export function getVote(obj: any) {
  return request({
    url: '/miniAppSaveVoteApiV2',
    method: 'get',
    params: obj,
  })
}